<template>
  <div class="a-container">
    <div class="content">
      <div class="login">
        <a-card>
          <div class="top">
            <img alt="logo" class="logo" :src="systemLogoDark" />
            <br />
            <br />
            <div class="desc">Welcome to {{ systemName }} Admin</div>
          </div>

          <a-form
            id="components-form-demo-normal-login"
            @submit="handleSubmit"
            :form="form"
          >
            <div
              size="large"
              :tabBarStyle="{ textAlign: 'center' }"
              style="padding: 0 2px"
            >
              <a-alert
                type="error"
                :closable="true"
                v-show="error"
                :message="error"
                showIcon
                style="margin-bottom: 24px"
              />
              <a-form-item>
                <a-input
                  v-decorator="[
                    'userEmail',
                    {
                      rules: [
                        { required: true, message: 'Please input your email!' }
                      ]
                    }
                  ]"
                  size="large"
                  placeholder="Enter email"
                >
                  <a-icon slot="prefix" type="user" />
                </a-input>
              </a-form-item>
              <a-form-item>
                <a-input-password
                  v-decorator="[
                    'password',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your Password!'
                        }
                      ]
                    }
                  ]"
                  size="large"
                  placeholder="Enter password"
                >
                  <a-icon slot="prefix" type="lock" />
                </a-input-password>
              </a-form-item>
            </div>

            <a-form-item>
              <a-checkbox
                v-decorator="[
                  'remember',
                  {
                    valuePropName: 'checked',
                    initialValue: true
                  }
                ]"
                >Remember me</a-checkbox
              >
            </a-form-item>
            <a-form-item>
              <a-button
                :loading="logging"
                style="width: 100%; margin-top: 24px"
                size="large"
                htmlType="submit"
                type="primary"
                >Login</a-button
              >
            </a-form-item>
            <!-- <div>
            <router-link style="float: right" to="/dashboard/dashboard">Register account</router-link>
            </div>-->
          </a-form>
        </a-card>
      </div>
    </div>
    <global-footer :link-list="linkList" :copyright="copyright" />
  </div>
</template>

<script>
import Vue from 'vue'
import GlobalFooter from '@/layouts/GlobalFooter'
import cookieType from '@/config/cookieType'
import UserService from '@/apiServices/UserService'
import moment from 'moment'
import { mapActions } from 'vuex';

export default {
  name: 'Login',
  components: { GlobalFooter },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'normal_login' }),
      logging: false,
      error: ''
    }
  },
  computed: {
    systemName() {
      return this.$store.state.AppSetting.systemName
    },
    systemLogoDark() {
      return this.$store.state.AppSetting.systemLogoDark
    },
    linkList() {
      return this.$store.state.AppSetting.footerLinks
    },
    copyright() {
      return this.$store.state.AppSetting.copyright
    }
  },
  beforeMount() {
    this.form.getFieldDecorator('userEmail', {
      initialValue: ''
    })
    this.form.getFieldDecorator('password', {
      initialValue: ''
    })
  },
  methods: {
    ...mapActions("user", ["getAssignedStudents"]),
    // handleSubmit(e) {
    //   let payload = {
    //     email: this.form.getFieldValue('userEmail'),
    //     password: this.form.getFieldValue('password')
    //   }

    //   if (
    //     payload.email === 'admin@binarynumbers.io' &&
    //     payload.password === 'admin'
    //   ) {
    //     this.$router.push("/dashboard")
    //     this.$store.dispatch('Account/onLoginUser', {
    //       name: 'RV',
    //       avatar: '@AVATAR',
    //       address: 'Mumbai',
    //       welcome: 'Welcome',
    //       timefix: `Date: ${moment().format('DD-MM-YYYY')}`,
    //       position: 'Admin'
    //     })
    //     this.$message.success('User Successfully logged in', 3)
    //   } else {
    //     this.error = 'Please enter valid email and password'
    //     this.logging = false
    //   }
    // }
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((formerror, values) => {
        let payload = {
          email: this.form.getFieldValue("userEmail"),
          password: this.form.getFieldValue("password"),
        };
        if (!formerror) {
          this.logging = true;
          UserService.Login({
            email: payload.email,
            password: payload.password,
          })
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.logging = false;
                console.log("data :>> ", data);
                console.log("data.data.token :>> ", data.data.token);
                Vue.cookie.set(cookieType.MCHASHID, data.data.token, "30d");
                this.$router.push("/dashboard");
                this.$store.commit("Account/SET_TOKEN", data.data.token);
                this.$store.dispatch("Account/onLoginUser", {
                  name: data.user.firstname,
                  avatar: "@AVATAR",
                  address: "Mumbai",
                  welcome: "Welcome",
                  timefix: `Date: ${moment().format("DD-MM-YYYY")}`,
                  // position: "Developer",
                });
                this.$message.success("User Successfully logged in", 3);
              } else {
                this.error = "Please enter valid email and password";
                this.logging = false;
              }
            })
            .catch((error) => {
              console.error(error);
              this.error = "Please enter valid email and password";
              this.logging = false;
            });
        }
      });
    },
  }
}
</script>

<style lang="less" scoped>
.a-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: auto;
  background: #f0f2f5 no-repeat center 110px;
  background-size: 100%;
  .content {
    padding: 32px 0;
    flex: 1;
    @media (min-width: 768px) {
      padding: 112px 0 24px;
    }

    .login {
      width: 440px;
      margin: 0 auto;
      .ant-input {
        width: 90% !important;
      }
      @media screen and (max-width: 576px) {
        width: 95%;
      }
      @media screen and (max-width: 320px) {
        .captcha-button {
          font-size: 14px;
        }
      }
      .top {
        text-align: center;
        .logo {
          height: 70px;
          vertical-align: top;
          margin-right: 16px;
        }
        .header {
          height: 44px;
          line-height: 44px;
          a {
            text-decoration: none;
          }

          .title {
            font-size: 33px;
            color: rgba(0, 0, 0, 0.85);
            font-family: 'Myriad Pro', 'Helvetica Neue', Arial, Helvetica,
              sans-serif;
            font-weight: 600;
            position: relative;
            top: 2px;
          }
        }
        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }
      .icon {
        font-size: 24px;
        color: rgba(0, 0, 0, 0.2);
        margin-left: 16px;
        vertical-align: middle;
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: #1890ff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/Login.vue